import { render } from "./Vraag.vue?vue&type=template&id=509ba78a&scoped=true"
import script from "./Vraag.vue?vue&type=script&lang=js"
export * from "./Vraag.vue?vue&type=script&lang=js"

import "./Vraag.vue?vue&type=style&index=0&id=509ba78a&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509ba78a"]])

export default __exports__